export default class IteratorNull {
    // Public:
    next() {}

    hasFinished() {
        return true;
    }

    getValue() {
        return undefined;
    }

    getIndex() {
        return undefined;
    }

    reset() {}

    setParent() {}
}
